import { useEffect } from 'react';
import { useField } from 'formik';
import DatePicker from 'react-datepicker';
import { InputGroup } from '@chakra-ui/react';
import 'react-datepicker/dist/react-datepicker.css';
import './style.css';
import dayjs from 'dayjs';

const MONTH_YEAR_PORTAL_ID = 'month-year-datepicker-portal';

const ensureMonthYearPortal = () => {
  if (!document.getElementById(MONTH_YEAR_PORTAL_ID)) {
    const portalDiv = document.createElement('div');
    portalDiv.id = MONTH_YEAR_PORTAL_ID;
    document.body.appendChild(portalDiv);
  }
};

export const MonthYearField = ({ item, field, formik }) => {
  const {
    name,
    label,
    isRequired,
    initialValue,
    disabled = false,
    isInline = false,
    enableTime = false,
    placeholder,
    min,
    max,
    className,
    popperPlacement = 'top',
    styleVersion = 'v1',
  } = item;

  const [formField, meta, helpers = {}] = useField(name);
  const { setValue, setTouched, setError } = helpers || {};
  const { error, touched } = meta;
  const value = formField?.value ?? meta?.value;
  const { submitCount } = formik || {};

  const showError = (submitCount > 0 || touched) && !value && isRequired;

  // Derive the picker value directly from the form state so it always reflects
  // formik — including async resume autofill that populates this dynamically-added
  // field after it has already mounted (a local state snapshot would stay stale).
  const resolved =
    value !== undefined && value !== null && value !== ''
      ? value
      : (initialValue ?? null);
  const selectedDate = resolved !== null ? new Date(resolved) : undefined;

  useEffect(() => {
    ensureMonthYearPortal();
  }, []);

  if (!item) return null;

  const handleOnChange = (date) => {
    setValue?.(date);
    setTouched?.(true);
    setError?.(null);
  };

  return (
    <InputGroup>
      <DatePicker
        id={name}
        name={name}
        required={isRequired}
        inline={isInline}
        disabled={disabled}
        errors={error}
        touched={touched}
        onBlur={field?.onBlur}
        selected={selectedDate}
        minDate={min ? dayjs(max).toDate() : undefined}
        onChange={handleOnChange}
        showTimeInput={enableTime}
        placeholderText={placeholder ? placeholder : `Select ${label}`}
        className={`ats-date-input-field ${
          showError
            ? styleVersion === 'v2'
              ? 'error-date-field-v2'
              : 'error-date-field'
            : ''
        } ${disabled ? 'disabled-field' : ''} ${className || ''}`}
        popperClassName={`month-year-popover`}
        dateFormat={'MM/yyyy'}
        showMonthYearPicker={true}
        popperPlacement={popperPlacement}
        maxDate={max ? dayjs(max).toDate() : undefined}
        autoComplete="off"
        portalId={MONTH_YEAR_PORTAL_ID}
      />
    </InputGroup>
  );
};
